import * as ApiHelper from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import type { RequestAQuoteFormData } from "../components/RequestAQuoteDialog/RequestAQuoteDialog";
import type { ProductConfiguratorPDFData } from "./apiGenerateDatasheet";

const baseUrl = resolveApiUrl("/configurator/{productcode}/contact-form/submit");

interface RequestAQuotePayload {
  formData: RequestAQuoteFormData;
  pdfData: ProductConfiguratorPDFData;
  quantity: number;
}

export async function apiRequestAQuote(
  productCode: string,
  quantity: number,
  formData: RequestAQuoteFormData,
  pdfData: ProductConfiguratorPDFData,
) {
  const url = baseUrl.replace("{productcode}", productCode);

  const payload: RequestAQuotePayload = {
    formData,
    pdfData,
    quantity,
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Failed to request quote: ${response.statusText}`);
  }
}
